import {
  GetUrlParamsRequest,
  GetUrlParamsResponse,
} from '../../../../custom-embedded-code-sdk/src/methods'
import { logger } from '../../../utils/logger'
import { ServiceHandler } from './service-registry'

type GetURLParamsReturn = Record<string, string[]>

/**
 * GET_URL_PARAMS service handler
 * Handles requests to retrieve all URL search parameters from the current page.
 * If no URL search parameters is found, simply return an empty object.
 *
 * Expected response format:
 * - Success: object containing all parameters key-value pairs
 * - Error: "error message"
 */
export const getUrlParams: ServiceHandler<GetUrlParamsRequest, GetUrlParamsResponse> = async ({
  iframeId,
  messageId,
  sendSuccessResponse,
  sendErrorResponse,
  pageConfig,
}) => {
  const campaignId = pageConfig.campaignId

  try {
    if (!campaignId) {
      throw new Error('CustomEmbeddedCode:getURLParams: Campaign ID not available')
    }

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString.split('?')[1])

    logger('info', 'CustomEmbeddedCode:getURLParams: Successfully retrieved URL parameters', {
      context: { iframeId, messageId, queryString },
    })

    if (queryString === '' || urlParams.size === 0) {
      return sendSuccessResponse(iframeId, messageId, {})
    }

    const params = [...urlParams].reduce((prev, [key, value]) => {
      prev[key] = prev[key] ? [...prev[key], value] : [value]
      return prev
    }, {} as GetURLParamsReturn)

    sendSuccessResponse(iframeId, messageId, params)
  } catch (err) {
    const locationSearch = window.location.search
    logger(
      'error',
      new Error('CustomEmbeddedCode:getURLParams: Failed to get URL parameters', { cause: err }),
      { context: { iframeId, messageId, locationSearch } },
    )
    sendErrorResponse(iframeId, messageId, 'Unable to get the URL parameters.')
  }
}
